<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-12-30 20:40:32
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-12-30 22:16:49
-->
<template>
  <el-dialog width="480px" :visible.sync="dialogVisible" :append-to-body='true' show-close @close="resetForms()" :close-on-click-modal="false">
    <template slot="title">
      <p><span>精选联盟主页链接</span></p>
    </template>
    <el-form
      :inline="true"
      :model="formData"
      label-width="140px"
      ref="from"
      :rules="rules"
    >
      <el-form-item label="精选联盟主页链接" prop="union_url">
        <el-input v-model="formData.union_url" placeholder="请输入达人的精选联盟主页链接" style="width: 290px;"></el-input>
        <p><a class="fz-14 link primary" href="https://yangxuan.feishu.cn/docs/doccngNEQwDciIarsO4TQ6AuICf" target="_blank">如何获取达人的精选联盟主页链接？</a></p>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="submit">确认</el-button>
    </span>
  </el-dialog>
</template>
<script>
import throttle from 'lodash/throttle';
import { editTalent } from '@/api/talentCRM'
export default {
  name: 'modifyDyId',
  data() {
    return {
      dialogVisible: false,
      formData: {
        anchor_id: '',
        union_url: '',
        anchor_account: '',
        anchor_name: '',
        is_effective: ''
      },
      rules: {
        union_url: [
          { required: true, message: '请输入精选联盟主页链接', trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    show(obj) {
      this.formData = {...obj};
      this.dialogVisible = true;
    },
    resetForms() {
      this.$refs['from'].resetFields();
    },
    submit: throttle(function() {
      this.$refs.from.validate(async valid => {
        if(!valid) return
        const { formData: {
          union_url,
          anchor_id,
          anchor_account,
          anchor_name,
          is_effective
        } } = this
        const { code } = await editTalent({anchor_id, union_url, anchor_account, anchor_name, is_effective})
        if(code !== 0) return
        this.$message.success('精选联盟主页链接添加成功')
        this.$emit('refresh')
        this.handleClose()
      });
    }, 1000),
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>